import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo } from "react";
import { ChecklistMaquinaEquipModel } from "../../../../domain/models/checklist_maquina_equip";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { ChecklistMaquinaEquipForm, ChecklistMaquinaEquipSchema, initialChecklistMaquinaEquipForm } from "../../../schemas/ChecklistMaquinaEquip_lista/checklist_maquina_equip";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ChecklistMaquinaEquipModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedChecklistMaquinaEquip: ChecklistMaquinaEquipModel | null,
  onClose: (idChecklistMaquinaEquip: number | null, openState: boolean) => void;
  onSubmit: (form: ChecklistMaquinaEquipForm) => void;
};

export const ChecklistMaquinaEquipModal = ({
  open,
  saving,
  loading,
  selectedChecklistMaquinaEquip,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ChecklistMaquinaEquipSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedChecklistMaquinaEquip) {
        hookForm.setValue('status', selectedChecklistMaquinaEquip.status ?? 1);
        hookForm.setValue('codigo', selectedChecklistMaquinaEquip.codigo ?? '');
        hookForm.setValue('nroRevisao', selectedChecklistMaquinaEquip.revisao ?? '');
        hookForm.setValue('descricao', selectedChecklistMaquinaEquip.descricao ?? '');

      } else {
        hookForm.reset({
          ...initialChecklistMaquinaEquipForm,
        });

        hookForm.setValue('status', 1);
      }
    }
  }, [
    open,
    selectedChecklistMaquinaEquip,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Checklist de Máquina/Equipamento'
      onClose={() => onClose(null, false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col">
        <FormContainer title='Informações' arrangement='fullRow' paddingTop="small" paddingBottom="normal" gap='small' border={false}>
          <>
            <FormSwitchInput
              name='status'
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='codigo'
              label='Código do Checklist'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='nroRevisao'
              label='Nº da revisão'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='descricao'
              label='Descrição do Checklist'
              readOnly={saving}
              required={true}
              multiline={true}
              rows={5}
              reactHookForm={hookForm}
            />

          </>
        </FormContainer>
      </div>
    </BaseFormControlledModal >
  );
}